// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"c6b4480a","377":"3493e9b1"}[chunkId] + ".chunk.js";
};